module.exports = __webpack_public_path__ + "static/media/C4.ad916352.PNG";